/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { MktuClassWord } from './MktuClassWord'
import {
  MktuClassWordFromJSON,
  MktuClassWordFromJSONTyped,
  MktuClassWordToJSON,
} from './MktuClassWord'

/**
 *
 * @export
 * @interface Search200ResponseData
 */
export interface Search200ResponseData {
  /**
   * Найденные фразы, сгруппированные в объект: ключ — искомое слово, значение — массив схем MktuClassWord
   * @type {{ [key: string]: Array<MktuClassWord>; }}
   * @memberof Search200ResponseData
   */
  groups: { [key: string]: Array<MktuClassWord> }
  /**
   * Слова, для которых не найдено соответствий в классах МКТУ
   * @type {Array<string>}
   * @memberof Search200ResponseData
   */
  undefined: Array<string>
}

/**
 * Check if a given object implements the Search200ResponseData interface.
 */
export function instanceOfSearch200ResponseData(
  value: object
): value is Search200ResponseData {
  if (!('groups' in value) || value['groups'] === undefined) return false
  if (!('undefined' in value) || value['undefined'] === undefined) return false
  return true
}

export function Search200ResponseDataFromJSON(
  json: any
): Search200ResponseData {
  return Search200ResponseDataFromJSONTyped(json, false)
}

export function Search200ResponseDataFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): Search200ResponseData {
  if (json == null) {
    return json
  }
  return {
    groups: json['groups'],
    undefined: json['undefined'],
  }
}

export function Search200ResponseDataToJSON(
  value?: Search200ResponseData | null
): any {
  if (value == null) {
    return value
  }
  return {
    groups: value['groups'],
    undefined: value['undefined'],
  }
}
